import { render, staticRenderFns } from "./FormHomeFooter.vue?vue&type=template&id=8d139f70&scoped=true&"
import script from "./FormHomeFooter.vue?vue&type=script&lang=js&"
export * from "./FormHomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./FormHomeFooter.vue?vue&type=style&index=0&id=8d139f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d139f70",
  null
  
)

export default component.exports